<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>
      <v-row class="pa-2" no-gutters>
        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 1" :ripple="true"> مشاهده QR </v-tab>

            <v-tab :ripple="true"> پیش نمایش </v-tab>
            <v-tab :ripple="true" :disabled="e6 <= 1">تعرفه‌ها</v-tab>

          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 10px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <div class="d-flex flex-column justify-center align-center">
                <qr-maker :loading="loading" :svg="svgMade" />
                <v-btn class="btn-download" @click="showDialog = true">
                  <v-icon>mdi-progress-download</v-icon>
                  {{ $t("download_qr") }}                </v-btn>
              </div>
            </v-tab-item>

            <v-tab-item>
              <TextMobile v-model="cardTexts" :orders.sync="cardTexts.orders" :qr-svg-data-url="qrSvgDataUrl"/>
            </v-tab-item>
            <v-tab-item v-if="!!info?.id && e6>1">
              <Tariffs :id_qr="info.id" :qrtype="'text'" />
          </v-tab-item>

          </v-tabs-items>
        </v-col>

        <v-col cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <!-- مرحله اول -->
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>وارد کردن اطلاعات کیوار متن</p>
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <v-text-field
                    v-model="cardTexts.visitName"
                    :disabled="e6 > 1"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="نام کیوآر متن"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="نام کیوآر متن"
                  />
                </div>

                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <qr-address-field
                    id="qr-address"
                    ref="address-field"
                    v-model="dtUrl"
                    :disabled="e6 > 1"
                    :error-messages="errors['identifier']"
                    append-icon="mdi-web"
                    class="mt-0 pt-0 contentinfo"
                    dense
                    :key="$t('qrAddressUpdate.hints.allowedChars')"
                    :hint="$t('qrAddressUpdate.hints.allowedChars')"
                    outlined
                    persistent-hint
                    @updateDest="domainId = $event"
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-dtUrl`"
                    label="آدرس کیوآر"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                  />
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <div class="col-md-12 mt-4">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr"
                />
              </div>
            </v-stepper-content>

            <!-- مرحله دوم -->
            <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2">
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
              <div class="mb-4">
            <!-- سوییچ و آیکون راهنما -->
            <div class="d-flex align-center">
              <v-switch
                v-model="AutoSave"
                color="primary"
                class="mt-0 pt-0 shrink"
                hide-details
                label="ذخیره خودکار"
              ></v-switch>

              <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
              <v-tooltip bottom max-width="320">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    x-small
                    class="mr-1"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop
                  >
                    <v-icon small color="grey darken-1">
                      mdi-help-circle-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>
                  تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                </span>
              </v-tooltip>
            </div>

            <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
            <div
              v-if="$vuetify.breakpoint.xsOnly"
              class="text-caption grey--text text--darken-1 mt-1 pr-1"
              style="line-height: 1.4"
            >
              تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
            </div>
          </div>


              <list-expansion
                v-model="cardTexts"
                :components="specialInfo"
                :data="cardTexts"
                :service-name="serviceName"
                :component-name="componentName"
                flat
                @save-required="AutoSave && qrUpdate(false)"
              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="qrUpdate(true)"
                />
              </div>
            </v-stepper-content>
          </v-stepper>

          <div class="d-none">
            <qr-code-make
              ref="qrCanvas"
              v-model="qrDesign"
              :file.sync="qrSvgDataUrl"
              :link="fullLink"
              @save="qrDesign = $event"
            />
          </div>

          <custom-popup
            v-model="showDialog"
            :cons="cons"
            hide-confirm
            max-width="900"
            transition="dialog-bottom-transition"
          >
            <template v-slot:helpinfo>
              <help-info
                :element-name="`${serviceName}-${componentName}-data-show-download-d`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="دانلود کیوآر"
              />
            </template>
            <v-card class="pa-5">
              <download-file-with-api
                v-if="showDialog"
               :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
                :visit-name="cardTexts.visitName"
                :qr_id="info.qrId"
                @close="showDialog = false"
              />
            </v-card>
          </custom-popup>
        </v-col>
      </v-row>
    </template>
      <QrIntroModal v-if="$vuetify.breakpoint.mdAndUp"
        storageKey="TextIntroSeen"
        title="کیوآر متن"
        :pro="false"
        icon="mdi-card-text-outline"
        iconColor="blue darken-1"
        :description="introText"
      />

  </help-info-wrapper>
</template>

<script>
import { getLanguageCookie } from "../../../../core/plugins/TitleRibbon/utils/languageCookie.js";
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrMaker from "@/view/pages/qrland/components/qrMaker.vue";
import TextMobile from "./component/TextMobile.vue";
import QrAddressField from "@/view/content/fragments/qrAddressField.vue";
import ListExpansion from "@/view/content/fragments/listExpansion.vue";
import NextBtn from "@/view/content/fragments/nextBtn.vue";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import DownloadFileWithApi from "@/view/pages/qrland/downloadFileWithApi.vue";
import { Bus } from "@/main";
import Tariffs from "../../../components/Tariffs/Tariffs.vue";
import QrIntroModal from "../../QrIntroModal.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "indexText",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    DownloadFileWithApi,
    QrCodeMake,
    NextBtn,
    ListExpansion,
    QrAddressField,
    QrMaker,
    Tariffs,
    TextMobile,
    QrIntroModal,
    AtomSpinner
  },

  data() {
    return {
      isAutoSaving: false, 
      AutoSave:false,
       ready:false,
      introText: `
        <strong>کیوآر متن</strong> یک راهکار مدرن و هوشمند برای اشتراک‌گذاری انواع یادداشت‌ها، بیوگرافی، اطلاعیه‌ها و پیام‌های اختصاصی است. با این کیوآر می‌توانید یک صفحه زیبا، خوانا و اختصاصی برای انتقال پیام‌های خود بسازید.
        <br><br>
        <strong>امکانات این صفحه:</strong>
        <br>
        <span style="padding-right: 15px; display: block;">
          <strong>۱. درج متن و محتوای نامحدود:</strong> ثبت دل‌نوشته‌ها، معرفی خدمات، توضیحات محصول یا پیام‌های اختصاصی بدون محدودیت کاراکتر.<br>
          <strong>۲. لینک‌ها و دکمه‌های تعاملی:</strong> افزودن پیوند وب‌سایت، شبکه‌های اجتماعی و راه‌های ارتباطی در بخش‌های مجزا.<br>
          <strong>۳. شخصی‌سازی و ویرایش لحظه‌ای:</strong> تغییر آنی متن، پالت‌های رنگی و تنظیمات صفحه در هر زمان بدون نیاز به چاپ مجدد کیوآر.
        </span>
        <br>
        این کیوآر بهترین انتخاب برای نامه‌های دیجیتال، معرفی برند یا شخص، راهنمای محصولات و پیام‌های ماندگار است.
      `,
      helpData: [],
      serviceName: "Qrland",
      componentName: "indexText",
      e6: 1,
      qrShow: 1,
      svgMade: "",
      createdId: null,
      createdDomain: null,
      dtUrl: null,
      domainId: null,
      showDialog: false,
      loading: false,
      errors: {},
      info: null,
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      cardTexts: {
        orders: [
          { name: "profile" },
          { name: "about" },
          { name: "extraFields" }
        ],
        pallete: {
          headColor: "linear-gradient(135deg, #0ea5e9, #6366f1)", 
          bodyColor: "linear-gradient(180deg, #0F172A 0%, #1e1b4b 50%, #021541 100%)",
          textColor: "#f8fafc",
          borderColor: "rgba(255, 255, 255, 0.15)",
          isDarkBody: true
        },
        visitName: "سامانه ترمینال تبلیغات",
        organizationName: "ترمینال تبلیغات",
        subtitle: "جامع‌ترین پلتفرم مدیریت، بهینه‌سازی و تحلیل تبلیغات آنلاین",
        aboutUs:
          "ترمینال تبلیغات\n\n" +
          "سامانه جامع و تخصصی بررسی، هدایت و مدیریت تبلیغات دیجیتال.\n\n" +
          "ما با بهره‌گیری از ابزارهای هوشمند و رویکرد داده‌محور، مسیر دیده‌شدن کسب‌وکارها و دستیابی به بالاترین نرخ بازگشت سرمایه (ROI) در کمپین‌های تبلیغاتی را هموار می‌کنیم.",
        extraFields: [
          {
            icon: "mdi-bullhorn-outline",
            name: "خدمات ما",
            value:
              "🚀 مدیریت و اجرای کمپین‌های تبلیغاتی هوشمند و هدفمند\n" +
              "📊 تحلیل دقیق رفتار مخاطبان و بهینه‌سازی بودجه تبلیغات\n" +
              "🔗 برای مشاهده خدمات و شروع مشاوره تخصصی کلیک کنید:",
            type: "link",
            link: "https://terminalads.com"
          },
          {
            icon: "mdi-qrcode-scan",
            name: "کیوآر هوشمند و پویا",
            value:
              "✨ این کیوآر کد از نوع داینامیک (پویا) است.\n" +
              "شما می‌توانید در هر زمان متون، اطلاعیه‌ها و پیوندهای این صفحه را بدون نیاز به تعویض یا چاپ مجدد کیوآر ویرایش کنید."
          },
          {
            icon: "mdi-shield-check-outline",
            name: "پشتیبانی",
            value:
              "🎯 ارائه گزارش‌های شفاف، پایش لحظه‌ای و همراهی همه‌جانبه برای رشد پایدار برند شما."
          }
        ],
        photo: {
          profile: "",
          transition: "scale",
          hasWelcome: false,
          showWelcome: false,
          hasGif: false,
          hasGame: false,
          previewerQr: {
            previewer: {
              gif: "",
              game: {},
              transition: "scale"
            }
          },
          headBackground: ""
        },
        PicSelector: {
          title: "",
          description: "",
          sectionColor: {
            backGround: "",
            text: ""
          },
          slider: false,
          grid: true
        },
        baseInfo: {
          sectionColor: {
            backGround: "linear-gradient(to right , #1e3c72, #2a5298)",
            text: "#ffffff"
          },
          slider: false,
          grid: false
        }
      },

      specialInfo: [
        {
          name: "baseInfo",
          value: "",
          title: "متن",
          icon: "text",
        },
        {
          name: "imageUploader",
          value: "",
          title: "لوگو/ پس زمینه",
          icon: "image",
          model: "photo",
        },
          {
          name: "colorPallete",
          value: "",
          title: this.$t("select_color"),
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
        },
      ],
      
      qrSvgDataUrl: "",
    };
  },

  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
      }
    },
  },
  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
    this.cardTexts.photo.profile =
      this.$coreApi3 + "/storage/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.png";

  },

  computed: {
    defaultroboatUrl() {
      return this.$cdnUrl + "/upload/64b1535578ce0.webp";
    },
    defaultProfileImage() {
      return (
        this.$coreApi3 + "/storage/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.png"
      );
    },
    defaultWebsite() {
      return this.$coreqrApi || "https://qr.terminalads.com";
    },
    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
  },

  methods: {
    markQr(final = false) {
      if (
        !this.dtUrl ||
        typeof this.$refs["address-field"].dtUrlRule(this.dtUrl) !== "boolean"
      ) {
        this.$toast.clear();
        this.$toast.error("آدرس وارد شده صحیح نمی‌باشد!");
        return;
      }

      this.loading = true;
      let obj = {
        type: "text",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
        qr: JSON.stringify(this.qrDesign),
      };
      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("/v1/testQr/store", obj)
        .then(({ data }) => {
          this.loading = false;
          this.createdDomain = this.$refs["address-field"].destItems.find(
            (item) => item.id === this.domainId,
          ).name;
          this.createdId = data.data.identifier;
          this.info = data.data;
          this.qrShow = 0;
          this.$toast.success("کیوآر متن شما با موفقیت ساخته شد.");
          if (this.e6 === 1) {
            this.e6 = 2;
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 500);
              setTimeout(() => {
                this.qrUpdate();
                this.qrShow = 1;
              }, 2000);
            });
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response.status === 422)
            this.$modal.error("خطا", response.data.message);
          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};

          if (response?.data?.errors) {
            const backendErrors = response.data.errors;

            Object.entries(backendErrors).forEach(
              ([fieldKey, fieldMessages]) => {
                try {
                  translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                    const key = errorMap[msg];
                    return key ? this.$t(key) : msg;
                  });

                  const msg = fieldMessages[0];
                  const key = errorMap[msg];
                  this.$toast.error(key ? this.$t(key) : msg, {
                    timeout: 3000,
                  });
                } catch (e) {
                  console.log("Error in mapping translation: ", e);
                }
              },
            );

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }

          let el = document.getElementById("qr-address");
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new FormData();
      data.append("type", "text");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");
      data.append("qr_id", this.info.qrId);
      data.append("_method", "PUT");
      data.append("qr", JSON.stringify(this.qrDesign));

      data.append(
        "data",
        JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
      );

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then((res) => {
          if (final) {
            this.$toast.success("کیوآر متن شما باموفقیت ویرایش شد.");
            this.goto("qr/list");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.isAutoSaving = false;
        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
